import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  constructor(private api: ApiService) {}

  // GET API

  getGlobalSearchEntityItems(keyword: string) {
    return this.api.get('/global-search/?office_id=' + this.api.getOfficeId() + '&property_address=' + keyword + '&filter=' + []);
  }
}
